import { IValues } from '../utils/common/types';

export const FORM_INITIAL_VALUES: IValues = {
  product: '',
  description: '',
  callToAction: '',
  tone: 'friendly',
  businessType: '',
  specialOffers: '',
  characterLimit: '',
  tellUsAboutYourself: '',
  textToParaphrase: '',
  language: 'english',
  wordToStart: '',
  numberOfResults: '10',
  keywords: '',
  purpose: '',
  adWriterRadioValue: 'body',
  describeYourImage: '',
  paragraphTitle: '',
  textToBeSummarised: '',
  format: 'short paragraph',
  textPurpose: '',
  describeText: '',
  describeScene: '',
  numberOfColors: '5',
  ideaGeneratorTopic: '',
  blogIdeaGeneratorTopic: '',
  bookIdeaGeneratorTopic: '',
  businessIdeaGeneratorTopic: '',
  contentIdeaGeneratorTopic: '',
  drawingIdeaGeneratorTopic: '',
  giftIdeaGeneratorTopic: '',
  paintingIdeaGeneratorTopic: '',
  sideHustleIdeaGeneratorTopic: '',
  startupIdeaGeneratorTopic: '',
  storyIdeaGeneratorTopic: '',
  articleWriterTopic: '',
  articleWriterDetails: '',
  seoCheckboxValue: true,
  length: 'medium',
  creativity: 'medium',
  describeStory: '',
  sloganPurpose: '',
  sloganWords: '',
  describeOutline: '',
  includeIdeas: '',
  outlinePurpose: '',
  describeTopic: '',
  metaTitleCheckbox: false,
  inputValue: '',
  dropdown01: '',
  dropdown02: 'English',
  essayInput: '',
  essayDetails: '',
  createInput: '',
  createDetails: '',
  titleGeneratorTopic: '',
  blogTitleGeneratorTopic: '',
  bookTitleGeneratorTopic: '',
  contentTitleGeneratorTopic: '',
  documentTitleGeneratorTopic: '',
  landingPageTitleGeneratorTopic: '',
  socialMediaPostTitleGeneratorTopic: '',
  storyTitleGeneratorTopic: '',
  videoTitleGeneratorTopic: '',
  videoScriptGeneratorTopic: '',
  videoScriptStyle: '',
  videoScriptLength: '',
  videoScriptComplexity: '',
  blogTitleGeneratorType: '',
  bookTitleGeneratorType: '',
  contentTitleGeneratorType: '',
  documentTitleGeneratorType: '',
  titleGeneratorType: '',
  landingPageTitleGeneratorType: '',
  socialMediaPostTitleGeneratorType: '',
  storyTitleGeneratorType: '',
  videoTitleGeneratorType: '',
  promptGeneratorTopic: '',
  promptGeneratorDetails: '',
  textPromptGeneratorTopic: '',
  textPromptGeneratorDetails: '',
  imagePromptGeneratorTopic: '',
  imagePromptGeneratorDetails: '',
  videoPromptGeneratorTopic: '',
  videoPromptGeneratorDetails: '',
  codePromptGeneratorTopic: '',
  codePromptGeneratorDetails: '',
  paragraphGeneratorTopic: '',
  paragraphGeneratorDetails: '',
  keywordsGeneratorTopic: '',
  keywordsGeneratorNumber: '',
};

export const TONE_VALUES = [
  {
    title: '😊 Friendly',
    value: 'friendly',
  },
  {
    title: '💎 Luxury',
    value: 'luxury',
  },
  {
    title: '😌 Relaxed',
    value: 'relaxed',
  },
  {
    title: '💼 Professional',
    value: 'professional',
  },
  {
    title: '💪 Bold',
    value: 'bold',
  },
  {
    title: '⛺ Adventurous',
    value: 'adventurous',
  },
  {
    title: '💡 Witty',
    value: 'witty',
  },
  {
    title: '🧠 Persuasive',
    value: 'persuasive',
  },
  {
    title: '😍 Empathetic',
    value: 'empathetic',
  },
];

export const LANGUAGE_VALUES = [
  {
    title: 'English/(US)',
    value: 'english',
  },
  {
    title: 'Simplified Chinese/中文(简体)',
    value: 'chinese',
  },
  {
    title: 'German/Deutsch',
    value: 'german',
  },
  {
    title: 'French/Français',
    value: 'french',
  },
  {
    title: 'Italian/Italiano',
    value: 'italian',
  },
  {
    title: 'India/Hindi',
    value: 'hindi',
  },
  {
    title: 'Japanese/日本',
    value: 'japanese',
  },
  {
    title: 'Korean/한국어',
    value: 'korean',
  },
  {
    title: 'Russian/Русский',
    value: 'russian',
  },
  {
    title: 'Spanish/Español',
    value: 'spanish',
  },
];

export const LANGUAGES_WITHOUT_WORD_COUNT = ['chinese', 'hindi', 'japanese', 'korean', 'russian'];
